export default "__VITE_ASSET__DVMaVz9i__"